<template>
  <article class="container-fluid">
    <PageHeader
      :page="page"
      has-return
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    >
      <template v-slot:customActions>
        <ActionButton
          v-if="showAddStudentAction && !showAddStudentSection"
          class="m-1"
          text="Añadir Estudiante"
          variant="outline-success"
          i="fas fa-file-plus"
          @click="toggleAddStundentSection"
        />
        <ActionButton
          v-if="!showAddStudentAction"
          class="m-1"
          text="Guardar"
          variant="success"
          i="fas fa-save"
          @click="onSaveServiceAssistant"
        />
      </template>
    </PageHeader>

    <ServiceAssistantList />

    <CustomTab
      ref="assistant-service-tabs"
      :no-nav-style="true"
      nav-class="nav-vue-underline"
    >
      <CustomTabItem
        :lazy="false"
        title="Información General"
        @click="toggleAddStudentAction(false)"
      >
        <ValidationObserver ref="main-form">
          <GeneralInformation
            :value="model"
            :collections="collections"
            :disabled="readonly"
            :invalid-school="invalidSchool"
          />
        </ValidationObserver>
      </CustomTabItem>

      <CustomTabItem
        v-if="showAddEstudentTab"
        :lazy="false"
        title="Estudiantes Asignados"
        @click="toggleAddStudentAction(true)"
      >
        <AssignStudents
          :value="model"
          :collections="collections"
          :show-add-student.sync="showAddStudentSection"
        />
      </CustomTabItem>
    </CustomTab>
  </article>
</template>

<script>
import ServiceAssistantList from './components/ServiceAssistantList.vue';
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import GeneralInformation from './tabs/tab1GeneralInformation';
import academicYearService from '@/services/academicyear';
import academicService from '@/services/api/academicUtils.api';
import resourcesService from '@/services/resources';
import EduEspCode from '@/utils/constants/eduEspCode';
import AssignStudents from './tabs/tab2AssignStudents';
import formDataUtil from '@/utils/formDataUtil';
import alert from '@/mixin/alert.mixin';
import {
  getNecessitiesList,
  getServiceAssistantById,
} from '@/modules/human-resources/api';
import {
  saveServiceAssistant,
  updateServiceAssistant,
} from '@/modules/service-assitant/api';
import { ValidationObserver } from 'vee-validate';

const modelInitialState = () => ({
  name: '',
  paternalSurname: '',
  maternalSurname: '',
  contactPhone: '',
  email: '',
  schools: [],
  assistanceAreas: [],
  hrAssistantId: null,
});

export default {
  name: 'AddEditReadServiceAssistant',
  mixins: [alert],
  components: {
    PageHeader,
    ActionButton,
    ServiceAssistantList,
    CustomTab,
    CustomTabItem,
    GeneralInformation,
    AssignStudents,
    ValidationObserver,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Manejo de Asistente de Servicio',
        routes: [
          'Inicio',
          'Recursos Humanos',
          'Manejo de Asistente de Servicio',
        ],
      },
      model: modelInitialState(),
      showAddEstudentTab: false,
      showAddStudentAction: false,
      showAddStudentSection: false,
      invalidSchool: false,
      collections: {
        studentList: [],
        academicYears: [],
        resourceTypes: [],
        assistantTypes: [],
        dailyShifts: [],
        necessities: [],
      },
      readonly: false,
    };
  },
  methods: {
    async onSaveServiceAssistant() {
      const isValid = await this.$refs['main-form'].validate();
      if (!isValid) return;

      if (this.model.schools.length == 0) {
        this.ShowToast(
          'Información incompleta',
          'Favor añadir al menos una escuela.',
          'error'
        );
        return;
      }

      if (this.model.hrAssistantId) {
        const { data } = await updateServiceAssistant(
          this.createSaveFormData(this.model.hrAssistantId)
        );

        if (data) {
          this.mapServiceAssistant(data);

          this.ShowToast(
            'Confirmación',
            'El asistente de servicio ha sido guardado exitosamente.',
            'success'
          );
        }
      } else {
        await saveServiceAssistant(this.createSaveFormData()).then((res) => {
          if (res.data != 0) {
            this.showAddEstudentTab = true;
            this.model.hrAssistantId = res.data;

            this.ShowToast(
              'Confirmación',
              'El asistente de servicio ha sido creado exitosamente.',
              'success'
            );

            this.$router.push(
              `/humanres/serviceAssistantManagement/edit/${this.model.hrAssistantId}`
            );
          }
        });
      }
    },
    createSaveFormData(id) {
      const formData = new FormData();

      if (id) {
        formDataUtil.build(formData, id, 'id');
      }

      formDataUtil.build(formData, this.model.name, 'name');
      formDataUtil.build(
        formData,
        this.model.paternalSurname,
        'paternalSurname'
      );
      formDataUtil.build(
        formData,
        this.model.maternalSurname,
        'maternalSurname'
      );
      formDataUtil.build(formData, this.model.contactPhone, 'contactPhone');
      formDataUtil.build(formData, this.model.email, 'email');
      formDataUtil.build(
        formData,
        this.model.assistanceAreas.map((a) => a.id),
        'NecessitiesId'
      );
      let AssistantSchools = this.model.schools.map((e) => {
        return {
          LocationSchoolId: e.school.id,
          ContractNumber: e.positionNumber,
          ResourceTypeId: e.resourceType.id,
          DailyShift: e.dailyShift.id,
          TimeInService: e.timeInService,
          AcademicYearId: e.academicYear.id,
          StartDate: e.fromDate?.toISOString(),
          EndTime: e.toDate?.toISOString(),
        };
      });
      formDataUtil.build(formData, AssistantSchools, 'AssistantSchools');
      return formData;
    },
    toggleAddStundentSection() {
      this.showAddStudentSection = !this.showAddStudentSection;
    },
    toggleAddStudentAction(value) {
      this.showAddStudentAction = value;
    },
    async fetchResources() {
      const {
        data: academicYearsList,
      } = await academicYearService.getAcademicYearFromMin({
        minYearId: 23,
        yearType: 'FUTURE',
      });
      this.collections.academicYears = academicYearsList;

      const { data: resourceTypeList } = await academicService.getEduEsp({
        codetype: EduEspCode.AuxiliaryType,
      });
      this.collections.resourceTypes = resourceTypeList;

      const { data: assistantTypeList } = await academicService.getEduEsp({
        codetype: EduEspCode.ResourceType,
      });
      this.collections.assistantTypes = assistantTypeList;

      const { data: dailyShiftList } = await academicService.getEduEsp({
        codetype: EduEspCode.DailyShift,
      });
      this.collections.dailyShifts = dailyShiftList.map((dailyShift) => ({
        ...dailyShift,
        name: `${dailyShift.name} horas`,
      }));

      const { data: necesitiesList } = await getNecessitiesList();
      this.collections.necessities = necesitiesList;

      this.collections.resources = await resourcesService.LoadValidationMessages(
        ['R01210005', 'R01210008', 'R01210009']
      );
    },
    async fetchServiceAssistant(id) {
      const data = await getServiceAssistantById(id);

      this.mapServiceAssistant(data);

      this.showAddEstudentTab = true;
    },
    mapServiceAssistant(dto) {
      this.model.hrAssistantId = dto.id;
      this.model.name = dto.name;
      this.model.paternalSurname = dto.paternalSurname;
      this.model.maternalSurname = dto.maternalSurname;
      this.model.contactPhone = dto.contactPhone;
      this.model.email = dto.email;
      this.model.schools = dto.schools.map((x) => ({
        ...x,
        positionNumber: x.contractNumber,
        fromDate: new Date(x.startDate),
        toDate: new Date(x.endDate),
      }));
      this.model.assistanceAreas = [...dto.necessities];
    },
    goBack() {
      this.$router.push({ name: 'ServiceAssistant' });
    },
  },
  async mounted() {
    await this.fetchResources();

    const serviceAssistantId = this.$route.params.id;
    if (serviceAssistantId) {
      await this.fetchServiceAssistant(serviceAssistantId);
    }
  },
};
</script>

<style></style>
